import { differenceInCalendarMonths, differenceInYears } from 'date-fns';

const MONTHS_IN_A_YEAR = 12;

export function getRentalPeriodYearsAndMonths(checkIn: Date, checkOut: Date) {
  const checkInMS = checkIn.getTime();
  const checkOutMS = checkOut.getTime();

  const rentalPeriodMonths = differenceInCalendarMonths(checkOutMS, checkInMS);
  const rentalPeriodYears = differenceInYears(checkOutMS, checkInMS);
  const monthsLeft = rentalPeriodMonths % MONTHS_IN_A_YEAR;

  return {
    years: rentalPeriodYears,
    months: monthsLeft,
  };
}

export function reFormatDate(dateString: string): string {
  const [day, month, year] = dateString.split('/');
  const reformattedDate = `${year}-${month}-${day}`;
  return reformattedDate;
}
